import React from "react";
import { Routes, Route, Outlet } from "react-router-dom";
import { ClubmeisterschaftSetupProvider } from "../../contexts/ClubmeisterschaftSetupProvider.jsx";
import { clearLocalState } from "@tennis-matches/services/persistence";
import { CLUBMEISTERSCHAFT_CHILD_ROUTES } from "@tennis-matches/clubmeisterschaft-core/manifests/clubmeisterschaft.manifest.js";
import { ClubChampIndexPage } from "./ClubChampIndexPage.jsx";

/**
 * Clubmeisterschaft-Routes (Root = Outlet, Child-Routes aus Manifest).
 * Index = ClubChamp-Hub-Dashboard (wie MatchMixer).
 */
export function ClubmeisterschaftAppWrapper({ state, t }) {
  const onNewTournament = () => {
    clearLocalState({ keepTenant: true });
  };

  const rootProps = {
    state,
    t,
    onNewTournament,
  };

  function ClubmeisterschaftRootLayout() {
    return <Outlet context={rootProps} />;
  }

  return (
    <Routes>
      <Route
        path="/clubmeisterschaft"
        element={<ClubmeisterschaftRootLayout />}
      >
        {CLUBMEISTERSCHAFT_CHILD_ROUTES.map((child) => {
          const { path, index } = child;
          if (index) {
            return <Route key="index" index element={<ClubChampIndexPage />} />;
          }
          const isSetup = path === "setup";
          const { Component } = child;
          const element = isSetup ? (
            <ClubmeisterschaftSetupProvider state={state} t={t}>
              <Component />
            </ClubmeisterschaftSetupProvider>
          ) : (
            <Component />
          );
          return <Route key={path} path={path} element={element} />;
        })}
      </Route>
    </Routes>
  );
}
